module.exports = __webpack_public_path__ + "img/green_044.9df12cbd.png";